// extracted by mini-css-extract-plugin
module.exports = {"title":"diji-blog-all-articles_title__bmMi2","root":"diji-blog-all-articles_root__yU0tD"};